export default __webpack_public_path__ + "static/media/reddit.68e0b723.png";